<template>
    <div class="finTxnDetailPopup">
        <b-modal id="finTxnDetailPopup" ref="finTxnDetailRef" @hide="closeDialog" size="lg" modal-class="" title="Transaction Details" ok-only>
            <div v-if="loading" id="loader"></div>
            <div v-if="!loading">
                <div id="printMe" class="row">
                    <div class="row mb-auto w-100 mx-0">
                        <div class="col-12 px-0 text-left">
                            <div class="card-body p-0 px-0 mx-0">
                                <div class="col-lg-12 col-xl-12 px-0">
                                    <div class="row">
                                        <div class="col-6 col-sm-6 mb-3 pr-1">
                                            <div class="row mb-0">
                                                <div class="col-2 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">{{ popupData.financialTransactionId }}</label>
                                                </div>
                                                <div class="col-10 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details font-weight-bold">{{ popupData.title }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pl-1">
                                            <div class="row mb-0">
                                                <div class="col-4 pr-0">
                                                    <label class="mb-2 p-1 pt-2 pb-2 d-block title-block">Amount</label>
                                                </div>
                                                <div class="col-6 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details text-right">{{ popupData.amount ? popupData.amount.toFixed(2) : '' }}</label>
                                                </div>
                                                <div  class="col-2 pl-0 ">
                                                    <label v-if="popupData.amountType=='CR'" class="p-2 mb-0 d-block header-details text-center green">{{ popupData.amountType }}</label>
                                                    <label v-if="popupData.amountType=='DR'" class="p-2 mb-0 d-block header-details text-center red">{{ popupData.amountType }}</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6 col-sm-6 pr-1">
                                            <div class="row mb-0">
                                                <div class="col-4 pr-0">
                                                    <label class="mb-2 p-1 pt-2 pb-2 d-block title-block">Type</label>
                                                </div>
                                                <div class="col-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.type }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pl-1">
                                            <div class="row mb-0">
                                                <div class="col-4 pr-0">
                                                    <label class="mb-2 p-1 pt-2 pb-2 d-block title-block">Category</label>
                                                </div>
                                                <div class="col-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.category }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pr-1">
                                            <div class="row mt-0 mb-2">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">Account Head</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.accountHead }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pl-1">
                                            <div class="row mt-0">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">Accountable</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.accountablePerson }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pr-1">
                                            <div class="row mt-0 mb-2">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-2 p-1 pt-2 pb-2 d-block title-block">Transaction Date</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.transactionDt | formatDateTimeAmPm }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pl-1">
                                            <div class="row mt-0">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">Transaction By</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.transactionBy }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pr-1">
                                            <div class="row mt-0 mb-2">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-2 p-1 pt-2 pb-2 d-block title-block">Fin. Txn Group</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{popupData.ermTitle}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-sm-6 pl-1">
                                            <div class="row mt-0">
                                                <div class="col-4 col-md-4 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">Created Date</label>
                                                </div>
                                                <div class="col-8 col-md-8 pl-0">
                                                    <label class="p-2 mb-0 d-block header-details">{{ popupData.createdDt | formatDateTimeAmPm }}</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-sm-12">
                                            <div class="row mt-0 mb-2">
                                                <div class="col-12 col-md-2 pr-0">
                                                    <label class="mb-0 p-1 pt-2 pb-2 d-block title-block">Attachment</label>
                                                </div>
                                                <div class="col-12 col-md-10 pl-0">
                                                    <div class="col-12">
                                                        <div class="mt-2">
                                                            <AttachmentView ref="viewAttachmentRef" :attachmentData="attachmentData" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer="{ ok }">
                <div class="w-100">
                    <b-button size="sm" variant="primary" @click="ok()" class="float-right" >OK</b-button>
                    <b-button title="Download" size="sm" variant="outline-primary" @click.prevent="print" class="float-left">
                        <i class="fa fa-download fa-lg"></i>
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import AttachmentView from '@/components/common/ViewAttachmentComponent.vue';    
export default {
    props: {
        referenceDetailId: Number,
        detailViewData: Object,
        attachmentData: Object
    },
    components: {
        AttachmentView
    },
    data() {
        return {
            loading: true,
            popupData: {},
            timeSheets: [],

            effortTypes: [
                { name: "Man Hours", id: 1 },
                { name: "Man Days", id: 2 },
                { name: "Man Months", id: 3 },
                { name: "Man Years", id: 4 },
            ],
        }
    },
    methods: {
        getDetails: function(id, refEntity) {
            this.loading = true;
            try {                
                this.$bvModal.show('finTxnDetailPopup');
                console.log(this.detailViewData);
                if (refEntity === "financial_transaction") {
                    axios.get(this.$store.getters.getAPIBasePath + '/finance/financialtransaction/view/' + id)
                    .then((response) => {
                        let result = response.data;
                        if (result) {
                            this.popupData = result.financialTransaction;
                            this.loading = false;
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error);
                    });
                }
                else {
                    this.$nextTick(() => {
                        this.popupData = this.detailViewData;
                    });
                    this.loading = false;
                } 
            }
            catch(err) {
                console.log(err);
                this.loading = false;
            }
        },
        print: function() {    
            this.$htmlToPaper('printMe');
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
}
</script>
<style scoped>
span >>> p {
    margin: 0;
}
</style>